<div class="alv-card">
  <div class="light-blue-text" style="text-align: right; float: right">
    {{ tunnistetietoObservable | async }}
  </div>

  @if (numbersLoadingSubject | async) {
    <div style="display: flex; height: 200px; justify-content: center; align-items: center">
      <mat-spinner mode="indeterminate"></mat-spinner>
    </div>
  }

  @if (!(numbersLoadingSubject | async) && alvIlmoitusSubject | async; as alvIlmoitus) {
    <h2 class="light-blue-text alv-otsikko" style="padding: 1em 0 0 0; margin: 0">Vero kotimaan myynneistä verokannoittain</h2>
    <div style="padding: 0 1em">
      <table class="alv-table">
        <tbody>
          <tr>
            <td>25,5% vero</td>
            <td>{{ alvIlmoitus?.alv255 | lmoney: 'EUR' | async }}</td>
          </tr>
          <tr>
            <td>24% vero</td>
            <td>{{ alvIlmoitus?.alv24 | lmoney: 'EUR' | async }}</td>
          </tr>
          <tr>
            <td>14% vero</td>
            <td>{{ alvIlmoitus?.alv14 | lmoney: 'EUR' | async }}</td>
          </tr>
          <tr>
            <td>13,5% vero</td>
            <td>{{ alvIlmoitus?.alv135 | lmoney: 'EUR' | async }}</td>
          </tr>
          <tr>
            <td>10% vero</td>
            <td>{{ alvIlmoitus?.alv10 | lmoney: 'EUR' | async }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <h2 class="light-blue-text alv-otsikko">Vero ostoista ja maahantuonneista</h2>
    <div style="padding: 0 1em">
      <table class="alv-table">
        <tbody>
          <tr>
            <td>Vero tavaraostoista muista EU-maista</td>
            <td>{{ alvIlmoitus?.taveu | lmoney: 'EUR' | async }}</td>
          </tr>
          <tr>
            <td>Vero palveluostoista muista EU-maista</td>
            <td>{{ alvIlmoitus?.palveu | lmoney: 'EUR' | async }}</td>
          </tr>
          <tr>
            <td>Vero tavaroiden maahantuonneista EU:n ulkopuolelta</td>
            <td>{{ alvIlmoitus?.taveieu | lmoney: 'EUR' | async }}</td>
          </tr>
          <tr>
            <td>Vero rakentamispalvelun ja metalliromun ostoista</td>
            <td>{{ alvIlmoitus?.rak | lmoney: 'EUR' | async }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <h2 class="light-blue-text alv-otsikko">Vähennettävä vero</h2>
    <div style="padding: 0 1em">
      <table class="alv-table">
        <tbody>
          <tr>
            <td>Verokauden vähennettävä vero</td>
            <td>{{ alvIlmoitus?.vahennettava | lmoney: 'EUR' | async }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    @if (naytaArhObservable | async) {
      <div style="background: rgb(229, 244, 250); padding: 1em">
        <div style="display: flex; justify-content: space-between">
          <div style="font-size: 18px; line-height: 30px">Alarajahuojennus</div>
          @if (!alvIlmoitus.arhLaskettu) {
            <app-button (click)="toggleArh()" actionId="Poista/Avaa alarajahuojennus">
              {{ naytaArh ? 'Poista alarajahuojennus ilmoitukselta' : '+ Avaa alarajahuojennus' }}
            </app-button>
          }
        </div>
        @if (alvIlmoitus.arhError) {
          <div class="lemon-error">
            <!-- <div style="font-size: 18px; line-height: 30px;">Lemonatorin laskema alarajahuojennus</div> -->
            @if (alvIlmoitus.arhError == 'no-alv') {
              <div>Lemonator ei voinut laskea alarajahuojennusta. Asiakkaalla ei ole voimassa olevaa ALV-ilmoituskautta.</div>
            }
            @if (alvIlmoitus.arhError == 'calculation-not-supported-for-alv-type') {
              <div>Lemonator ei voinut laskea alarajahuojennusta. Asiakkaan voimassa olevalla ALV-ilmoitusjaksotyypillä ei voi hakea alarajahuojennusta.</div>
            }
            @if (alvIlmoitus.arhError == 'alv-change-during-tilikausi') {
              <div>Lemonator ei osaa laskea alarajahuojennusta automaattisesti, koska ALV-jakso on vaihtunut kesken tilikauden. Laske alarajahuojennus käsin ja syötä se tähän.</div>
            }
            @if (alvIlmoitus.arhError == 'not-eligible-due-to-too-short-tilikausi') {
              <div>Asiakas ei ole oikeutettu alarajahuojennukseen liian lyhyen tilikauden takia. Vain tilikaudella olevat täydet kuukaudet lasketaan mukaan ja tällaisia kuukausia on oltava enemmän kuin yksi.</div>
            }
            @if (alvIlmoitus.arhError == 'arh-disabled-after-2024') {
              <div>31.12.2024 jälkeen loppuvien tilikausien ARH laskennat ja ilmoittamainen on tehtävä manuaalisesti OmaVeroon. Alarajahuojennus poistuu verovuonna 2025 pysyvästi.</div>
            }
          </div>
        } @else {
          @if (alvIlmoitus.arhLaskettu; as laskettu) {
            <div style="margin-bottom: 2em">
              <table class="alv-table">
                <tbody>
                  <tr>
                    <td>Laskettu liikevaihto</td>
                    <td>{{ laskettu.suhteutettuLiikevaihto | lmoney: 'EUR' | async }}</td>
                  </tr>
                  <tr>
                    <td>Laskettu vero</td>
                    <td>{{ laskettu.vero | lmoney: 'EUR' | async }}</td>
                  </tr>
                  <tr>
                    <td>Laskettu alarajahuojennuksen määrä</td>
                    <td>{{ laskettu.huojennus | lmoney: 'EUR' | async }}</td>
                  </tr>
                </tbody>
              </table>
              <div style="text-align: right">
                <app-primary-button (click)="kopioiArhIlmoitukselle(alvIlmoitus)" [disabled]="true" actionId="Vie lasketut alarajahuojennuksen arvot ilmoitukselle"> Vie lasketut arvot ilmoitukselle </app-primary-button>
              </div>
              <!-- <pre>{{laskettu | json}}</pre> -->
            </div>
          }
        }
        @if (naytaArh || alvIlmoitus.arhLaskettu) {
          <div>
            @if (!alvIlmoitus.arhLaskettu && !alvIlmoitus.arhError) {
              <div style="margin: 1em; font-size: 16px; line-height: 26px" class="lemon-error">Alarajahuojennusta ollaan ilmoittamassa kaudella, jota Lemonator ei tue. Alarajahuojennus on laskettava itse.</div>
            }
            <table class="alv-table">
              <tbody>
                <tr>
                  <td>Alarajahuojennukseen oikeuttava liikevaihto</td>
                  <td><input type="text" decimalNumberField [showAllDecimals]="true" [allowNegative]="false" class="input currency" [formField]="arhLomake.arhLiikevaihto" autocomplete="kirjanpitoaineistoarkki" data-lpignore="true" /></td>
                </tr>
                <tr>
                  <td>Alarajahuojennukseen oikeuttava vero</td>
                  <td><input type="text" decimalNumberField [showAllDecimals]="true" [allowNegative]="false" class="input currency" [formField]="arhLomake.arhVero" autocomplete="kirjanpitoaineistoarkki" data-lpignore="true" /></td>
                </tr>
                <tr>
                  <td>Alarajahuojennuksen määrä</td>
                  <td>{{ alvIlmoitus.arhSyotetty?.huojennus | lmoney: 'EUR' | async }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        }
      </div>
    }
    <div style="padding: 1em; background-color: gray; margin-top: 1em">
      <table class="alv-table" style="color: white; font-size: 18px; line-height: 30px">
        <tbody>
          <tr>
            <td>Maksettava vero / palautukseen oikeuttava vero</td>
            <td>{{ maksettavaTaiPalautettavaVeroObservable | async | lmoney: 'EUR' | async }}</td>
          </tr>
          <tr>
            <td>Aiemman ilmoituksen mukainen vero</td>
            <td>{{ edellinenMaksettavaTaiPalautettavaVeroObservable | async | lmoney: 'EUR' | async }}</td>
          </tr>
          <tr>
            <td>Muutos veron määrässä</td>
            <td>{{ muutosVeronMaarassaObservable | async | lmoney: 'EUR' | async }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <h2 class="light-blue-text alv-otsikko">Myynnit, ostot ja maahantuonnit</h2>
    <div style="padding: 0 1em">
      <table class="alv-table">
        <tbody>
          <tr>
            <td>0-verokannan alainen liikevaihto</td>
            <td>{{ alvIlmoitus?.nolla | lmoney: 'EUR' | async }}</td>
          </tr>
          <tr>
            <td>Tavaroiden myynnit muihin EU-maihin</td>
            <td>{{ alvIlmoitus?.tavmyynniteu | lmoney: 'EUR' | async }}</td>
          </tr>
          <tr>
            <td>Palveluiden myynnit muihin EU-maihin</td>
            <td>{{ alvIlmoitus?.palvmyynniteu | lmoney: 'EUR' | async }}</td>
          </tr>
          <tr>
            <td>Tavaraostot muista EU-maista</td>
            <td>{{ alvIlmoitus?.tavostoeu | lmoney: 'EUR' | async }}</td>
          </tr>
          <tr>
            <td>Palveluostot muista EU-maista</td>
            <td>{{ alvIlmoitus?.palvostoeu | lmoney: 'EUR' | async }}</td>
          </tr>
          <tr>
            <td>Tavaroiden maahantuonnit EU:n ulkopuolelta</td>
            <td>{{ alvIlmoitus?.tavulkeu | lmoney: 'EUR' | async }}</td>
          </tr>
          <tr>
            <td>Rakentamispalvelun ja metalliromun myynnit (käännetty verovelvollisuus)</td>
            <td>{{ alvIlmoitus?.rakmetmyynti | lmoney: 'EUR' | async }}</td>
          </tr>
          <tr>
            <td>Rakentamispalvelun ja metalliromun ostot</td>
            <td>{{ alvIlmoitus?.rakmetosto | lmoney: 'EUR' | async }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- <div *ngIf="errorMessageObservable | async; as virhe" class="lemon-error" style="margin: 20px; font-weight: bold; text-align: center;">
    {{ virhe }}
  </div>
  <div *ngIf="arhVirhe" class="lemon-error" style="margin: 20px; font-weight: bold; text-align: center;">
    {{ arhVirhe }}
  </div>
  <div style="padding: 0 1em; margin-bottom: -15px; margin-top: 15px;" *ngIf="!(alvLaskunSahkoinenLaskutusosoiteKunnossaObservable | async)">
    <div style="font-size: 75%;" class="gray-text">ALV-lasku voidaan lähettää ainoastaan sähköisenä. Voit lisätä osoitteen navigoimalla Asetukset -> Laskutus.</div>
  </div> -->
    <!-- <div style="display: flex; padding: 0 1em;">
  <mat-checkbox [formControl]="alvLaskuSendCtrl" style="margin-top: 15px; margin-right: 5px;">
    Lähetä myös sähköinen alv-lasku summalla
  </mat-checkbox>
  <mat-form-field style="width: 100px;">
    <input style="display: inline-block;" decimalNumberField [name]="namename" type="text" [formControl]="alvLaskuMaaraCtrl" autocomplete="nothing" [numberOfDecimals]="2" matInput required /> -->
    <!-- <mat-error>{{fieldErrors.huomautuskulu}}</mat-error> -->
    <!-- </mat-form-field>
</div> -->
    <!-- <div style="padding: 0 1em;" *ngIf="alvLaskunSahkoinenLaskutusosoiteKunnossaObservable | async">
<div class="error-text" *ngIf="asiakkaanOsoitetiedotPuuttuvatObservable | async">ALV-laskua ei voi lähettää. Asiakkaan osoitetiedot puuttuvat. (Mene Asetukset -> Asiakastiedot ja tarkista, että katuosoite, postinumero ja postitoimipaikka on täytetty)</div>
<div class="error-text" *ngIf="!(alvLaskunViitenumeroObservable | async)">ALV-laskua ei voi lähettää. Asiakkaalta puuttuu verohallinnon sähköinen osoite. Ota yhteys tekniseen tukeen asiakaslinkin kera.</div>
</div> -->
    <!-- <div style="display: flex; justify-content: center; margin-top: 1.5em;">
<app-primary-button [disabled]="!(voidaanLahettaaObservable | async)" (click)="laheta()" actionId="Lähetä ALV-ilmoitus" styles="line-height: 35px;">
  <i *ngIf="alvLaskuSendCtrl.value" style="font-size: 20px; margin-right: 10px;" class="icon ion-ios-flash"></i> Lähetä
</app-primary-button>
<app-primary-button *ngIf="voidaanLahettaaVaikkaTiedotEivatMuuttuneetObservable | async" (click)="lahetaUudelleenVaikkaTiedotEivatMuuttuneet()" actionId="Avasi dialogin: Lähetä ALV-ilmoitus uudelleen (vain superit)" styles="line-height: 35px; margin-left: 15px;">
  Lähetä uudelleen, vaikka tiedot eivät muuttuneet (VAIN SUPERIT)
</app-primary-button>
</div> -->
  }
  <div style="position: relative; height: 20px">
    <div style="text-align: right; position: absolute; right: 15px; bottom: -5px; color: darkgray; font-size: 80%; width: 600px">
      {{ tallennustiedotObservable | async }}
      @if (tallentamattomiaMuutoksiaObservable | async) {
        <span style="font-size: 16px; position: absolute; top: -17px; right: -14px"> Ilmoittamattomia veroja kaudelta {{ tunnistetietoObservable | async }} <i class="fa fa-exclamation-triangle yellow-text" style="font-size: 20px; padding-left: 3px"></i></span>
      }
    </div>
  </div>
</div>

<!-- <app-button (click)="laskeAutomaattikirjauksetUudelleen()" actionId="Päätä ALV-tilit (automaattikirjaus)">
Päätä ALV-tilit (automaattikirjaus)
</app-button> -->

<div>
  <h3 class="light-blue-text alv-otsikko" style="margin: 1em 0">Lähetetyt ALV-ilmoitukset</h3>

  @if (historyLoadingSubject | async) {
    <div style="display: flex; height: 200px; justify-content: center; align-items: center">
      <mat-spinner mode="indeterminate"></mat-spinner>
    </div>
  }

  <div [style.display]="(historyLoadingSubject | async) ? 'none' : 'block'">
    @for (edellinenIlmoitus of aikaisemmatVersiotObservable | async; track edellinenIlmoitus) {
      <div class="alv-card dark-gray-text">
        <div class="" style="text-align: right; float: right">
          {{ edellinenIlmoitus.tunnistetiedotString }}
        </div>
        @if (edellinenIlmoitus.url) {
          <div style="clear: both">
            Data: <a [href]="edellinenIlmoitus.url" target="_BLANK">{{ edellinenIlmoitus.uri }}</a>
          </div>
        }
        <h2 class="alv-otsikko" style="padding: 1em 0 0 0; margin: 0">Vero kotimaan myynneistä verokannoittain</h2>
        <div style="padding: 0 1em">
          <table class="alv-table">
            <tbody>
              <tr>
                <td>25,5% vero</td>
                <td>{{ edellinenIlmoitus.alv255 | lmoney: 'EUR' | async }}</td>
              </tr>
              <tr>
                <td>24% vero</td>
                <td>{{ edellinenIlmoitus.alv24 | lmoney: 'EUR' | async }}</td>
              </tr>
              <tr>
                <td>14% vero</td>
                <td>{{ edellinenIlmoitus.alv14 | lmoney: 'EUR' | async }}</td>
              </tr>
              <tr>
                <td>13,5% vero</td>
                <td>{{ edellinenIlmoitus.alv135 | lmoney: 'EUR' | async }}</td>
              </tr>
              <tr>
                <td>10% vero</td>
                <td>{{ edellinenIlmoitus.alv10 | lmoney: 'EUR' | async }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <h2 class="alv-otsikko">Vero ostoista ja maahantuonneista</h2>
        <div style="padding: 0 1em">
          <table class="alv-table">
            <tbody>
              <tr>
                <td>Vero tavaraostoista muista EU-maista</td>
                <td>{{ edellinenIlmoitus.taveu | lmoney: 'EUR' | async }}</td>
              </tr>
              <tr>
                <td>Vero palveluostoista muista EU-maista</td>
                <td>{{ edellinenIlmoitus.palveu | lmoney: 'EUR' | async }}</td>
              </tr>
              <tr>
                <td>Vero tavaroiden maahantuonneista EU:n ulkopuolelta</td>
                <td>{{ edellinenIlmoitus.taveieu | lmoney: 'EUR' | async }}</td>
              </tr>
              <tr>
                <td>Vero rakentamispalvelun ja metalliromun ostoista</td>
                <td>{{ edellinenIlmoitus.rak | lmoney: 'EUR' | async }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <h2 class="alv-otsikko">Vähennettävä vero</h2>
        <div style="padding: 0 1em">
          <table class="alv-table">
            <tbody>
              <tr>
                <td>Verokauden vähennettävä vero</td>
                <td>{{ edellinenIlmoitus.vahennettava | lmoney: 'EUR' | async }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        @if (edellinenIlmoitus.arhSyotetty) {
          <div style="background: rgb(229, 244, 250); padding: 1em">
            <div style="font-size: 18px; line-height: 30px">Alarajahuojennus</div>
            <table class="alv-table">
              <tbody>
                <tr>
                  <td>Alarajahuojennukseen oikeuttava liikevaihto</td>
                  <td>{{ edellinenIlmoitus.arhSyotetty.suhteutettuLiikevaihto | lmoney: 'EUR' | async }}</td>
                </tr>
                <tr>
                  <td>Alarajahuojennukseen oikeuttava vero</td>
                  <td>{{ edellinenIlmoitus.arhSyotetty.vero | lmoney: 'EUR' | async }}</td>
                </tr>
                <tr>
                  <td>Alarajahuojennuksen määrä</td>
                  <td>{{ edellinenIlmoitus.arhSyotetty.huojennus | lmoney: 'EUR' | async }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        }
        <div style="padding: 1em; background-color: gray; margin-top: 1em">
          <table class="alv-table" style="color: white; font-size: 18px; line-height: 30px">
            <tbody>
              <tr>
                <td>Maksettava vero / palautukseen oikeuttava vero</td>
                <td>{{ edellinenIlmoitus.maksettavaTaiPalautettavaVero | lmoney: 'EUR' | async }}</td>
              </tr>
              <tr>
                <td>Aiemman ilmoituksen mukainen vero</td>
                <td>{{ edellinenIlmoitus.edellinenMaksettavaTaiPalautettavaVero | lmoney: 'EUR' | async }}</td>
              </tr>
              <tr>
                <td>Muutos veron määrässä</td>
                <td>{{ edellinenIlmoitus.maksettavaTaiPalautettavaVero - edellinenIlmoitus.edellinenMaksettavaTaiPalautettavaVero | lmoney: 'EUR' | async }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <h2 class="alv-otsikko">Myynnit, ostot ja maahantuonnit</h2>
        <div style="padding: 0 1em">
          <table class="alv-table">
            <tbody>
              <tr>
                <td>0-verokannan alainen liikevaihto</td>
                <td>{{ edellinenIlmoitus.nolla | lmoney: 'EUR' | async }}</td>
              </tr>
              <tr>
                <td>Tavaroiden myynnit muihin EU-maihin</td>
                <td>{{ edellinenIlmoitus.tavmyynniteu | lmoney: 'EUR' | async }}</td>
              </tr>
              <tr>
                <td>Palveluiden myynnit muihin EU-maihin</td>
                <td>{{ edellinenIlmoitus.palvmyynniteu | lmoney: 'EUR' | async }}</td>
              </tr>
              <tr>
                <td>Tavaraostot muista EU-maista</td>
                <td>{{ edellinenIlmoitus.tavostoeu | lmoney: 'EUR' | async }}</td>
              </tr>
              <tr>
                <td>Palveluostot muista EU-maista</td>
                <td>{{ edellinenIlmoitus.palvostoeu | lmoney: 'EUR' | async }}</td>
              </tr>
              <tr>
                <td>Tavaroiden maahantuonnit EU:n ulkopuolelta</td>
                <td>{{ edellinenIlmoitus.tavulkeu | lmoney: 'EUR' | async }}</td>
              </tr>
              <tr>
                <td>Rakentamispalvelun ja metalliromun myynnit (käännetty verovelvollisuus)</td>
                <td>{{ edellinenIlmoitus.rakmetmyynti | lmoney: 'EUR' | async }}</td>
              </tr>
              <tr>
                <td>Rakentamispalvelun ja metalliromun ostot</td>
                <td>{{ edellinenIlmoitus.rakmetosto | lmoney: 'EUR' | async }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- <div style="margin-top: 5px; height: 20px; color: darkgray; font-size: 80%; display: flex; justify-content: space-between;">
        <div>
          <span *ngIf="edellinenIlmoitus?.alvLasku">Lähetetty sähköinen <a style="color: blue; cursor: pointer;" (click)="lataaAlvLasku(edellinenIlmoitus)">lasku</a> summalla {{ edellinenIlmoitus.alvLasku.maksettavaMaara | lmoney: 'EUR' | async}}</span>
          <span *ngIf="!edellinenIlmoitus?.alvLasku && edellinenIlmoitus.maksettavaTaiPalautettavaVero - edellinenIlmoitus.edellinenMaksettavaTaiPalautettavaVero > 0 && alvLaskunPerustiedotKunnossaObservable | async">
            <app-button (click)="lahetaVainAlvLasku(edellinenIlmoitus)" [actionId]="'Lähetä sähköinen alv-lasku summalla ' + ((edellinenIlmoitus.maksettavaTaiPalautettavaVero - edellinenIlmoitus.edellinenMaksettavaTaiPalautettavaVero) | lmoney: 'EUR' | async)">Lähetä sähköinen alv-lasku summalla {{ edellinenIlmoitus.maksettavaTaiPalautettavaVero -
              edellinenIlmoitus.edellinenMaksettavaTaiPalautettavaVero | lmoney: 'EUR' | async}}
            </app-button>
          </span>
        </div>
        <div style="text-align: right;">
          {{edellinenIlmoitus.tallennustiedot}} (Lähetys #{{ edellinenIlmoitus.jarjestysnumero }})
          <app-icon-button (click)="lataaTyviTiedosto(edellinenIlmoitus)" actionId="Lataa aiempi alv-ilmoitus koneelle" additionalClass="light-blue-text" styles="margin-top: -10px; margin-right: -10px;" matIcon="save">
          </app-icon-button>
        </div>
      </div> -->
      </div>
    }
  </div>

  <!-- <div app-kirjanpito-lahetys-alv *ngIf="alvLaskunPerustiedotKunnossaObservable | async" [valittuKuukausiObservable]="valittuKuukausiObservable"></div> -->
</div>
